export default {
    "dynamicFormsMain_forms": "Formularios",
    "dynamicFormsMain_answers": "Respuestas"
}